import React , {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import loader from '../../assets/Images/loader.gif';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const BusinessNewContactManagement = () => {
    const [loading, setLoading] = useState(false);
    const [flag,setFlag]=useState(false);
    const [newContactDataAll, setNewContactDataAll] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [searchFilter, setSearchFilter] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
          try {
            setLoading(true);
    
            const currentDate = new Date();
            const formattedCurrentDate = currentDate.toISOString().split('T')[0];
            const toDate = formattedCurrentDate;
    
            const fromDate = new Date(currentDate);
            fromDate.setMonth(currentDate.getMonth() - 2);
            const formattedFromDate = fromDate.toISOString().split('T')[0];
    
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
              Action: "getAllContactNew",
              Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
              businessSegment: "Business",
              fromDate: formattedFromDate,
              password: sessionStorage.getItem('password'),
              searchBoxValue: "",
              status: "All",
              toDate: toDate,
              userName: sessionStorage.getItem('userName'),
            };
    
            const response = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(requestData),
            });
    
            if (response.ok) {
              const result = await response.json();
              // console.log("api response",result);
              if (result.Status === 'Success' && result.response && result.response.StatusCode === 200 && result.response.Data !== undefined) {
                // console.log('Actual Data:', result.response.Data);
                setNewContactDataAll(result.response.Data); // Set fetched data to state
            }  else {
                const errorMessage = result && result.Response && result.Response.Message;
                toast.warning(`${errorMessage}`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
              }
            } else {
              // console.error('Error fetching data:', response.status);
                toast.warning(`${response.status}`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
            }
          } catch (error) {
            // console.error('Error fetching data:', error);
            toast.warning(error, {
              position: toast.POSITION.BOTTOM_CENTER,
              autoClose: 1500,
            });
          } finally {
            setLoading(false);
          }
        };
    
        fetchData();
      }, []);
    
      const handleSearch = async () => {
        try {
          setLoading(true);
          const apiUrl = process.env.REACT_APP_API_URL;
          const requestData = {
            Action: "getAllContact",
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            businessSegment: "Business",
            fromDate: "",
            password: sessionStorage.getItem('password'),
            searchBoxValue: searchInput,
            status: "not equal closed",
            toDate: "",
            userName: sessionStorage.getItem('userName'),
          };
          // Fetch data from the API
          const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          });
            const result = await response.json();
            if (result && result.Response && result.Response.Data) {
              setSearchFilter(result.Response.Data);
              setFlag(true);
            } else {
              // console.error("Invalid response format:", result);
              const errorMessage = result && result.Response && result.Response.Message;
                toast.warning(`${errorMessage}`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
            }
        } catch (error) {
          console.error("Error fetching data:", error);
                toast.warning(`${error}`, {
                  position: toast.POSITION.BOTTOM_CENTER,
                  autoClose: 1500,
                });
        } finally {
          setLoading(false);
        }
      };

      const navigate=useNavigate()
    const getContactForm=(ContactId)=>{
        navigate(`/newcontactform?ContactId=${ContactId}`);
    }
    const redirectBusinessPage=()=>{
        navigate('/business')
    }
    const redirectNewContactsForm=()=>{
        navigate('/newcontactform')
    }
  return (
    <>
        <div className="container-fluid text-light Header-style header">
            <div className="p-3">
                <span className='' style={{cursor:'pointer'}} onClick={redirectBusinessPage}>
                    <i className="fa-solid fa-arrow-left-long"></i>
                </span>
                <span className='p-1 m-3'>All Contacts</span>
            </div>
        </div>

        <div className='search-bar' style={{marginTop:"62px"}}>
            <div className="container-fluid mb-3 mt-1 p-2 Searchbar-bg">
                <div className="container d-flex justify-content-md-end justify-content-center align-items-center">
                    <span>
                    <input type="text" className='search-box p-1 border-0' placeholder="Search" style={{ width: '250px' }} 
                     value={searchInput} onChange={(e) => setSearchInput(e.target.value)} />
                      <i className="fas fa-search text-secondary" style={{ marginLeft: '-25px' }}></i>
                    </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <button className='btn-sm border-0 bg-light' onClick={handleSearch} 
                    >Search</button>
                </div>
            </div>
        </div>

        {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  !flag && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {newContactDataAll.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => getContactForm(contact.ContactId)}>
                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                          <p className="contact-card-text">Mobile No : {contact.MobileNumber ? contact.MobileNumber : "NA"}</p>
                          <p className="contact-card-text">Email ID : {contact.EmailAddress ? contact.EmailAddress : "NA"}</p>
                          <p className="contact-card-text">Contact Status : {contact.Status ? contact.Status : "NA"}</p>
                          <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                          <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              ))}

              {loading ? (
                  <div className="loader-wrapper">
                    <div className="loader">
                    <img src={loader} alt='loading....' ></img>
                    </div>
                  </div>
                ) : (
                  flag && (
                <div className='container-fluid'>
                  <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                    {searchFilter.map((contact, index) => (
                    <div className="col" key={index}>
                      <div className="card mb-3" onClick={() => getContactForm(contact.ContactId)}>
                        <div className="m-3 card-data" style={{ display: "inline-flex" }}>
                          <div>
                          <p className="contact-card-title">{contact.FullName} ({contact.ContactId})</p>
                          <p className="contact-card-text">Mobile No : {contact.MobileNumber ? contact.MobileNumber : "NA"}</p>
                          <p className="contact-card-text">Email ID : {contact.EmailAddress ? contact.EmailAddress : "NA"}</p>
                          <p className="contact-card-text">Contact Status : {contact.Status ? contact.Status : "NA"}</p>
                          <p className="contact-card-text">Created on : {contact.CreatedOn}</p>
                          <p className="contact-card-text">Created By : {contact.CreatedBy}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>)
            )}


        {/* ***********************  Add Icon************************** */}
        <div className='position-fixed bottom-0 end-0 m-4' onClick={redirectNewContactsForm}>
            <span className='bg-dark rounded-circle faPlus-icon'>
                <i className="fa-solid fa-plus fa-lg text-light m-1"></i>
            </span>
        </div>

    </>
  )
}

export default BusinessNewContactManagement;
